import { PLAYER_DEFAULT_MOVEMENTSPEED } from "../../../game-data/player-formulas"
import { EnemyBipedSkinType, SpineDataName } from "../../../spine-config/spine-config"
import { VariantAI } from "../ai-types"
import { ENEMY_NAME } from "../enemy-names"

export const HUGE_SHAMBLING_MOUND_SCALE = 2.5
export const DEFAULT_HUGE_SHAMBLING_MOUND_KNOCKBACK_RESIST = 6

export const hugeShamblingMound: VariantAI = {
    extends: ENEMY_NAME.SHAMBLING_MOUND,
    name: ENEMY_NAME.HUGE_SHAMBLING_MOUND,
    appearance: {
        asset: SpineDataName.SHAMBLING_MOUND_1,
        spriteSheet: true,
        skin: EnemyBipedSkinType.DEFAULT,
		scale: HUGE_SHAMBLING_MOUND_SCALE
    },
	knockbackResist: DEFAULT_HUGE_SHAMBLING_MOUND_KNOCKBACK_RESIST,
	maxHealth: 8,
}

export const shamblingMound2: VariantAI = {
    extends: ENEMY_NAME.SHAMBLING_MOUND,
    name: ENEMY_NAME.SHAMBLING_MOUND_2,
    appearance: {
        asset: SpineDataName.SHAMBLING_MOUND_2,
        spriteSheet: true,
        skin: EnemyBipedSkinType.DEFAULT
    },
	movementSpeed: PLAYER_DEFAULT_MOVEMENTSPEED * 0.64,
}

export const hugeShamblingMound2: VariantAI = {
    extends: ENEMY_NAME.SHAMBLING_MOUND_2,
    name: ENEMY_NAME.HUGE_SHAMBLING_MOUND_2,
    appearance: {
        asset: SpineDataName.SHAMBLING_MOUND_2,
        spriteSheet: true,
        skin: EnemyBipedSkinType.DEFAULT,
		scale: 2.5
    },
	maxHealth: 8,
	knockbackResist: DEFAULT_HUGE_SHAMBLING_MOUND_KNOCKBACK_RESIST
}

export const shamblingMound3: VariantAI = {
    extends: ENEMY_NAME.SHAMBLING_MOUND,
    name: ENEMY_NAME.SHAMBLING_MOUND_3,
    appearance: {
        asset: SpineDataName.SHAMBLING_MOUND_3,
        spriteSheet: true,
        skin: EnemyBipedSkinType.DEFAULT
    },
	movementSpeed: PLAYER_DEFAULT_MOVEMENTSPEED * 0.68,
}

export const hugeShamblingMound3: VariantAI = {
    extends: ENEMY_NAME.SHAMBLING_MOUND_3,
    name: ENEMY_NAME.HUGE_SHAMBLING_MOUND_3,
    appearance: {
        asset: SpineDataName.SHAMBLING_MOUND_3,
        spriteSheet: true,
        skin: EnemyBipedSkinType.DEFAULT,
		scale: HUGE_SHAMBLING_MOUND_SCALE
    },
	maxHealth: 8,
	knockbackResist: DEFAULT_HUGE_SHAMBLING_MOUND_KNOCKBACK_RESIST
}

export const shamblingMound4: VariantAI = {
    extends: ENEMY_NAME.SHAMBLING_MOUND,
    name: ENEMY_NAME.SHAMBLING_MOUND_4,
    appearance: {
        asset: SpineDataName.SHAMBLING_MOUND_4,
        spriteSheet: true,
        skin: EnemyBipedSkinType.DEFAULT
    },
	movementSpeed: PLAYER_DEFAULT_MOVEMENTSPEED * 0.72,
}

export const hugeShamblingMound4: VariantAI = {
    extends: ENEMY_NAME.SHAMBLING_MOUND_4,
    name: ENEMY_NAME.HUGE_SHAMBLING_MOUND_4,
    appearance: {
        asset: SpineDataName.SHAMBLING_MOUND_4,
        spriteSheet: true,
        skin: EnemyBipedSkinType.DEFAULT,
		scale: HUGE_SHAMBLING_MOUND_SCALE
    },
	maxHealth: 8,
	knockbackResist: DEFAULT_HUGE_SHAMBLING_MOUND_KNOCKBACK_RESIST
}


export const shamblingMound5: VariantAI = {
    extends: ENEMY_NAME.SHAMBLING_MOUND,
    name: ENEMY_NAME.SHAMBLING_MOUND_5,
    appearance: {
        asset: SpineDataName.SHAMBLING_MOUND_5,
        spriteSheet: true,
        skin: EnemyBipedSkinType.DEFAULT
    },
	movementSpeed: PLAYER_DEFAULT_MOVEMENTSPEED * 0.76,
}

export const hugeShamblingMound5: VariantAI = {
    extends: ENEMY_NAME.SHAMBLING_MOUND_5,
    name: ENEMY_NAME.HUGE_SHAMBLING_MOUND_5,
    appearance: {
        asset: SpineDataName.SHAMBLING_MOUND_5,
        spriteSheet: true,
        skin: EnemyBipedSkinType.DEFAULT,
		scale: HUGE_SHAMBLING_MOUND_SCALE
    },
	maxHealth: 8,
	knockbackResist: DEFAULT_HUGE_SHAMBLING_MOUND_KNOCKBACK_RESIST
}